import { render, staticRenderFns } from "./EmployeesEnquirySalariesPaids.vue?vue&type=template&id=79a0482e&"
import script from "./EmployeesEnquirySalariesPaids.vue?vue&type=script&lang=js&"
export * from "./EmployeesEnquirySalariesPaids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports